import React from "react";
import { useDispatch } from "react-redux";
import { Grid } from "@material-ui/core";
import { useParams } from "react-router-dom";
import CircularLoader from "components/Loaders/CircularLoader";
import InvoiceAttachmentsTable from "./Table/index";
import AttachmentForm from "./Form/index";
import {
	fetchInvoiceAttachmentsDocTypes,
	fetchInvoiceAttachments,
} from "../../../../../redux/actions/invoices";

export default () => {
	const dispatch = useDispatch();
	const [loaded, setLoaded] = React.useState(false);
	const { idInvoice } = useParams();

	React.useEffect(() => {
		dispatch(
			fetchInvoiceAttachmentsDocTypes(() => {
				setLoaded(true);
			})
		);
		dispatch(fetchInvoiceAttachments(idInvoice));
	}, []);

	return (
		<>
			{loaded ? (
				<Grid container xs={12}>
					<AttachmentForm />
					<InvoiceAttachmentsTable />
				</Grid>
			) : (
				<CircularLoader />
			)}
		</>
	);
};
